import React from 'react';

import { ReactComponent as LoadingLogo } from './loading-logo.svg';

const LoadingMessageComponent: React.FunctionComponent<any> = () => (
  <div className="u-width-100 u-height-100 u-alignItems-center u-display-flex u-justifyContent-center u-margin-xl">
    <LoadingLogo />
    <div className="typo-h4 u-color-gray u-margin-left">Loading...</div>
  </div>
);

export const LoadingMessage = React.memo(LoadingMessageComponent);
